var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit"},[_c('p',[_vm._v(_vm._s(_vm.title)+"：")]),_c('p',{class:{'no-wrap':_vm.title=='结论'}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }